import { Component, Input,OnInit } from '@angular/core';
import { User } from '../../../models/identity/user.model';
import { EventsAnalyticsService } from '../../../services/shared/events-analytics-service';
import { PosthogService } from '../../../services/shared/posthog.service';
import { FEATURE_FLAGS } from '../../../constants/feature-flags';

@Component({
    selector: 'app-contact-modal',
    templateUrl: './contact-modal.component.html',
    styleUrls: ['./contact-modal.component.scss'],
})
export class ContactModalComponent implements OnInit {
    @Input() user: User;

    showContact = false;
    psccConnectLaunchFeatureFlag: boolean;
    showEmail: boolean;
    ngOnInit(): void {
        this.psccConnectLaunchFeatureFlag = this.posthogService.isFeatureEnabled(FEATURE_FLAGS.PSCC_CONNECT_LAUNCH);
        this.showEmail = !!this.user.email && (!this.user.hideEmail && this.psccConnectLaunchFeatureFlag);
    }

    constructor(readonly eventsAnalyticsService: EventsAnalyticsService, private readonly posthogService: PosthogService) { }

    showContactDialog() {
        this.showContact = true;

        this.eventsAnalyticsService.userContactClicked(this.user.userId);
    }
}
